import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkAuth(state.url);
  }

  canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkAuth(state.url);
  }

  private checkAuth(returnUrl: string = '/'): Observable<boolean> {
    return this.authService.validateAuth().pipe(
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        } else {
          // Redirigir a la página de inicio de sesión con la URL de retorno
          this.router.navigate(['/iniciar-sesion'], { queryParams: { returnUrl } });
          return false;
        }
      }),
      catchError((error) => {
        console.error('Error durante la autenticación:', error);
        this.router.navigate(['/iniciar-sesion'], { queryParams: { returnUrl } });
        return of(false);
      })
    );
  }
}
